<template>
    <div id="visitorChatList">
        <a-spin :spinning="loading">
            <div v-if="chats.length > 0">
                <div id="visitor-history-list" style="top: 90px; bottom: 30px; width: 100%">
                    <div v-for="chat of chats" class="item" @click="() => selectChat(chat)">
                        <div style="margin-right: 28px">
                            <a-avatar
                                :size="40"
                                :src="chat.users.length ? chat.users[0].gravatar : undefined"
                                :style="{ backgroundColor: '#ffa800' }"
                                :username="chat.users.length ? chat.users[0].name : chat.fullname"
                            >
                                <div style="font-size: 14px">
                                    {{ ((chat.fullname ? chat.fullname : "User") || "*").substr(0, 1).toUpperCase() }}
                                </div>
                            </a-avatar>
                        </div>
                        <div class="content w-100">
                            <div class="d-flex justify-content-between w-100">
                                <span class="participant">{{ chat.fullname }}</span>
                                <span class="time">{{ getDate(chat) }}</span>
                            </div>
                            <div class="visitor-messages">
                                <span v-html="messageText(getLastMessage(chat).description)"></span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-5">
                    <a-pagination v-model:current="page" show-quick-jumper :total="totalCount" />
                </div>
            </div>
            <div class="data-box" v-else>
                <div class="last-session-info">
                    <div class="material-icons" style="font-size: 20px">block</div>
                    <div class="last-session-data" style="margin-top: 5px">No user data were found</div>
                </div>
            </div>
        </a-spin>
    </div>
</template>

<script>
import { log2 } from "../../../utils/log2";
import * as _ from "lodash";
import moment from "moment";
import { fetchChatHistory } from "../../../api/visitor";
import { htmlUnescape } from "escape-goat";
import Autolinker from "autolinker";
import { mapState } from "vuex";

const log = log2("VisitorChatList");

export default {
    name: "VisitorChatList",
    components: {},
    props: {
        visitorId: {
            type: String,
        },
    },
    data: () => ({
        chats: [],
        loading: true,
        totalCount: 10,
        pageSize: 1,
        page: 1,
        perPage: 5,
        conversation: [],
    }),
    computed: {
        ...mapState({
            site: (state) => state.site.site,
        }),
    },
    mounted() {
        moment.locale(this.$i18n.locale);
        this.getChatHistory();
    },
    methods: {
        selectChat(c) {
            if (c && c._id) {
                let conversationId = c._id;
                this.$router.push(`/archives/${this.visitorId}?&selectedChatId=${c._id}&allTime=1`);
                this.$emit("detailClose");
            }
        },
        getFirstMessage(c) {
            log("getFirstMessage", { c, test: c.messages[c.messages.length - 2] });
            return c.messages[c.messages.length - 2];
        },
        messageText(msg) {
            log("messageText...", msg);

            let escaped = htmlUnescape(msg.trim());

            let res = Autolinker.link(escaped, {
                className: "chatLink",
                truncate: { length: 50, location: "smart" },
            });

            res = res.replace(/<p>&nbsp;<\/p>$/gi, "");

            const regexp = /image/g;
            const matches = res.match(regexp);

            if (!!matches) {
                const regexp2 = /<img\b[^>]*>/g;
                const updatedHtml = res.replace(regexp2, '<img style="height: 40px; width:40px"$&');

                return updatedHtml;
            } else {
                return res;
            }
        },
        getLastMessage(c) {
            log("getLastMessage", c);
            return c.messages[c.messages.length - 1];
        },
        getDate(c) {
            return moment(c.createdDate).fromNow();
        },
        getChatHistory() {
            this.loading = true;
            fetchChatHistory(this.site._id, this.visitorId, this.page, this.perPage).then((res) => {
                const { conversations, totalCount, currentPage, pageSize } = res.data;
                this.totalCount = totalCount;
                this.pageSize = Math.ceil(totalCount / this.perPage);
                this.chats = conversations.filter((x) => x.messages.length > 0);
                this.loading = false;
            });
        },
    },
    watch: {
        page() {
            this.getChatHistory();
        },
    },
};
</script>

<style lang="scss">
#visitorChatList {
    #visitor-history-list {
        color: var(--color7) !important;
        display: flex;
        flex-direction: column;
        border: 1px solid #dbe1e8;

        .last-session-data {
            max-width: 200px;
            color: #516173;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
        }

        .data-box {
            border: 1px solid #dbe1e8;
            border-radius: 4px;
            -webkit-box-shadow: 0 1px 1px 0 rgb(0 0 0 / 13%);
            box-shadow: 0 1px 1px 0 rgb(0 0 0 / 13%);
            padding: 25px;
            display: grid;
            width: 100%;
        }

        .last-session-info {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }

        .item {
            width: 100%;
            display: flex;
            padding: 14px 14px;
            cursor: pointer;
            align-items: center;
            border-bottom: 1px solid #dbe1e8;

            .content {
                padding-left: 4px;
                overflow: hidden;
            }

            .time {
                font-size: 16px;
                line-height: 20px;
                color: #516173;
                font-weight: 500;
            }

            .participant {
                color: #22272d;
                font-weight: 500;
                font-size: 16px;
                line-height: 20px;
                width: 70%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .visitor-messages {
                .chatLink {
                    color: #516173 !important;
                }

                span {
                    max-height: 60px;
                    -webkit-line-clamp: 3;
                    font-size: 15px;
                    margin-top: 5px;
                    color: #516173;
                }
            }
        }
    }
}
</style>
